<template>
  <div>
    <div class="FilesBlock" :class="{ Edit: showEditLink }" v-show="card.files.length || showEditLink">
      <div class="Zg">Файлы и документы для скачивания</div>
      <div class="FilesLine">
        <div class="FileBox" v-for="(file, index) in card.files">
          <a class="FileLink" :href="file.download_link" download>
            <div class="FileIcon" :class="file.type"></div>
            <div class="FileOpisanie" :href="file.download_link">{{ file.title }}</div>
          </a>
          <div class="EditBlock" v-if="showEditLink">
            <div class="GearBt" @click="showEditFile(index)"></div>
            <div class="DelBt" @click="deleteFile(index)"></div>
          </div>
        </div>
      </div>
      <div class="AddBlock Files" @click="showAddFile" v-if="showEditLink">ДОБАВИТЬ</br>ФАЙЛ</div>
    </div>

    <div class="PopUpAdd" id="PopUpF" v-show="editMode">
      <div class="PopUpFon" @click="offEditMode"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock" style="height: 360px;">
          <div class="PopUpName" style="color: #37bbd6; font-style: bold">{{ editFileTitle() }}</div>
          <div class="PopUpClose" @click="offEditMode"></div>
          <div class="Rline3"></div>
          <form @submit.prevent="saveFile">
            <input type="file" class="FileLoad" ref="cardFileFileInput" value="Выберете файл" @change="selectedNewFileFile($event)"></br>
            <textarea maxlength='120' class='FileOpisForma' placeholder="Описание к файлу в 120 знаков." v-model="editFile().title"></textarea>
            <input type="submit" class="BtFileLoad" value="ЗАГРУЗИТЬ">
          </form>
          <div class="FLError" v-show="newFileError">{{ newFileError }}</div>
          <!-- <div class="Login">Ваш email или телефон</div>
          <div class="Pass">********</div>
          <div class="BtEnter">Войти</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pick } from 'lodash';

export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveData: Function
  },
  data() {
    return {
      editMode: false,
      newFile: {},
      newFileFile: null,
      newFileError: null,
      editFileIndex: -1
    };
  },
  methods: {
    onEditMode() {
      this.editMode = true;
      // console.log('Card component onEditMode', this.editMode);
    },
    offEditMode() {
      this.editMode = false;
      // console.log('Card component offEditMode', this.editMode);
    },
    showAddFile() {
      this.editFileIndex = -1;
      this.newFileFile = null;
      this.$refs.cardFileFileInput.value = null;
      this.newFileError = null;
      this.onEditMode();
    },
    showEditFile(index) {
      this.editFileIndex = index;
      this.newFileFile = null;
      this.$refs.cardFileFileInput.value = null;
      this.newFileError = null;
      // console.log('Card component showeditFile', index, this.editFile());
      this.onEditMode();
    },
    editFile() {
      return this.editFileIndex == -1 ? this.newFile : this.card.files[this.editFileIndex];
    },
    editFileTitle() {
      return this.editFileIndex == -1 ? "ДОБАВИТЬ ФАЙЛ" : "ИЗМЕНИТЬ ФАЙЛ";
    },
    selectedNewFileFile(event) {
      console.log('selectedNewFileFile', event, event.target.files[0]);
      if (event.target.files[0]) {
        this.newFileError = null;
        this.newFileFile = event.target.files[0];
      } else {
        // this.newFileError = "Выберете файл";
        this.newFileFile = null;
      }
      // console.log('selectedNewFileFile', this.newFileFile);
    },
    saveFile() {
      // console.log('saveFile', this.newFileFile);
      // if (!this.newFileFile) {
      //   this.newFileError = "Выберете файл";
      //   return;
      // }

      // console.log('saveFile', this.editFile());

      const formData = new FormData();
      const prefix = "card[files][]";
      if (this.editFile().id)
        formData.append(`${prefix}[id]`, this.editFile().id);
      formData.append(`${prefix}[title]`, this.editFile().title);
      if (this.newFileFile)
        formData.append(`${prefix}[file]`, this.newFileFile);
      console.log('formData', formData);

      this.saveData(formData, this.offEditMode, ['files']);
      if (!this.editFile().id) this.newFile = {};
    },
    deleteFile(index) {
      const file = pick(this.card.files[index], ['id']);
      file['_destroy'] = '1';
      console.log('deleteFile', file);
      const params = {files: [file]};
      this.editFileIndex = -1;
      this.saveData({card: params}, false, ['files']);
    },
  }
};
</script>
